module.exports = __webpack_public_path__ + "static/media/icon-eye-white-fill.d35c17ba.svg";